/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../graphql/types';

import { ExecutionResult } from 'graphql';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CategoryProductFragment = {
  readonly __typename?: 'Product';
  readonly calories: number;
  readonly categoryId: string;
  readonly cost: number;
  readonly description: string;
  readonly id: string;
  readonly isModifiable: boolean;
  readonly isCustom: boolean;
  readonly customType: Types.CustomProductType | null;
  readonly isSalad: boolean;
  readonly name: string;
  readonly outOfStock: boolean;
  readonly restaurantId: string;
  readonly slug: string;
  readonly throttleItem: boolean;
  readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
  readonly ingredients: ReadonlyArray<{
    readonly __typename?: 'Ingredient';
    readonly id: string;
    readonly name: string;
    readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
  }>;
  readonly label: {
    readonly __typename?: 'ProductLabel';
    readonly id: string;
    readonly name: string;
  } | null;
  readonly dietaryProperties: ReadonlyArray<{
    readonly __typename?: 'DietaryProperty';
    readonly id: string;
    readonly name: Types.DietaryPropertyKind;
  }>;
};

export type CategoryFragment = {
  readonly __typename?: 'MenuCategory';
  readonly id: string;
  readonly name: string;
  readonly isCustom: boolean;
  readonly products: ReadonlyArray<{
    readonly __typename?: 'Product';
    readonly calories: number;
    readonly categoryId: string;
    readonly cost: number;
    readonly description: string;
    readonly id: string;
    readonly isModifiable: boolean;
    readonly isCustom: boolean;
    readonly customType: Types.CustomProductType | null;
    readonly isSalad: boolean;
    readonly name: string;
    readonly outOfStock: boolean;
    readonly restaurantId: string;
    readonly slug: string;
    readonly throttleItem: boolean;
    readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
    readonly ingredients: ReadonlyArray<{
      readonly __typename?: 'Ingredient';
      readonly id: string;
      readonly name: string;
      readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
    }>;
    readonly label: {
      readonly __typename?: 'ProductLabel';
      readonly id: string;
      readonly name: string;
    } | null;
    readonly dietaryProperties: ReadonlyArray<{
      readonly __typename?: 'DietaryProperty';
      readonly id: string;
      readonly name: Types.DietaryPropertyKind;
    }>;
  }>;
};

export type RestaurantMenuFragment = {
  readonly __typename?: 'Restaurant';
  readonly id: string;
  readonly slug: string;
  readonly name: string;
  readonly city: string;
  readonly state: string;
  readonly zipCode: string;
  readonly address: string;
  readonly phone: string;
  readonly isOutpost: boolean;
  readonly isAcceptingOrders: boolean;
  readonly notAcceptingOrdersReason: string;
  readonly deliveryFee: number;
  readonly flexMessage: string | null;
  readonly hours: {
    readonly __typename?: 'RestaurantHours';
    readonly formatted: string | null;
  };
  readonly menu: {
    readonly __typename?: 'Menu';
    readonly id: string;
    readonly categories: ReadonlyArray<{
      readonly __typename?: 'MenuCategory';
      readonly id: string;
      readonly name: string;
      readonly isCustom: boolean;
      readonly products: ReadonlyArray<{
        readonly __typename?: 'Product';
        readonly calories: number;
        readonly categoryId: string;
        readonly cost: number;
        readonly description: string;
        readonly id: string;
        readonly isModifiable: boolean;
        readonly isCustom: boolean;
        readonly customType: Types.CustomProductType | null;
        readonly isSalad: boolean;
        readonly name: string;
        readonly outOfStock: boolean;
        readonly restaurantId: string;
        readonly slug: string;
        readonly throttleItem: boolean;
        readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
        readonly ingredients: ReadonlyArray<{
          readonly __typename?: 'Ingredient';
          readonly id: string;
          readonly name: string;
          readonly asset: {
            readonly __typename?: 'Asset';
            readonly url: string;
          };
        }>;
        readonly label: {
          readonly __typename?: 'ProductLabel';
          readonly id: string;
          readonly name: string;
        } | null;
        readonly dietaryProperties: ReadonlyArray<{
          readonly __typename?: 'DietaryProperty';
          readonly id: string;
          readonly name: Types.DietaryPropertyKind;
        }>;
      }>;
    }>;
  };
};

export type RestaurantQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type RestaurantQuery = {
  readonly __typename?: 'Query';
  readonly restaurant: {
    readonly __typename?: 'Restaurant';
    readonly id: string;
    readonly slug: string;
    readonly name: string;
    readonly city: string;
    readonly state: string;
    readonly zipCode: string;
    readonly address: string;
    readonly phone: string;
    readonly isOutpost: boolean;
    readonly isAcceptingOrders: boolean;
    readonly notAcceptingOrdersReason: string;
    readonly deliveryFee: number;
    readonly flexMessage: string | null;
    readonly hours: {
      readonly __typename?: 'RestaurantHours';
      readonly formatted: string | null;
    };
    readonly menu: {
      readonly __typename?: 'Menu';
      readonly id: string;
      readonly categories: ReadonlyArray<{
        readonly __typename?: 'MenuCategory';
        readonly id: string;
        readonly name: string;
        readonly isCustom: boolean;
        readonly products: ReadonlyArray<{
          readonly __typename?: 'Product';
          readonly calories: number;
          readonly categoryId: string;
          readonly cost: number;
          readonly description: string;
          readonly id: string;
          readonly isModifiable: boolean;
          readonly isCustom: boolean;
          readonly customType: Types.CustomProductType | null;
          readonly isSalad: boolean;
          readonly name: string;
          readonly outOfStock: boolean;
          readonly restaurantId: string;
          readonly slug: string;
          readonly throttleItem: boolean;
          readonly asset: {
            readonly __typename?: 'Asset';
            readonly url: string;
          };
          readonly ingredients: ReadonlyArray<{
            readonly __typename?: 'Ingredient';
            readonly id: string;
            readonly name: string;
            readonly asset: {
              readonly __typename?: 'Asset';
              readonly url: string;
            };
          }>;
          readonly label: {
            readonly __typename?: 'ProductLabel';
            readonly id: string;
            readonly name: string;
          } | null;
          readonly dietaryProperties: ReadonlyArray<{
            readonly __typename?: 'DietaryProperty';
            readonly id: string;
            readonly name: Types.DietaryPropertyKind;
          }>;
        }>;
      }>;
    };
  } | null;
};

export const restaurantQueryMock: ExecutionResult<RestaurantQuery> = {
  data: {
    restaurant: {
      id: 'e509e6ea-9fee-442a-9962-587ce7190430',
      slug: 'Hello World',
      name: 'Hello World',
      city: 'Hello World',
      state: 'Hello World',
      zipCode: 'Hello World',
      address: 'Hello World',
      phone: 'Hello World',
      isOutpost: true,
      hours: { formatted: 'Hello World' },
      isAcceptingOrders: true,
      notAcceptingOrdersReason: 'Hello World',
      deliveryFee: 38,
      flexMessage: 'Hello World',
      menu: {
        id: 'Hello World',
        categories: [
          {
            id: 'a7163ba7-eda9-46e8-a185-e3da00a9a475',
            name: 'Hello World',
            isCustom: false,
            products: [
              {
                asset: { url: 'Hello World' },
                calories: -56,
                categoryId: 'Hello World',
                cost: -82,
                description: 'Hello World',
                id: '9d08060b-59aa-4250-b9c4-016b1bd634cb',
                ingredients: [
                  {
                    asset: { url: 'Hello World' },
                    id: '73b7f9f1-8d03-40f1-b1f2-c49f5fd7994c',
                    name: 'Hello World',
                  },
                ],
                isModifiable: true,
                isCustom: true,
                customType: 'BOWL',
                isSalad: true,
                label: {
                  id: 'ab38b748-5afb-4e88-932e-de7a1daa933e',
                  name: 'Hello World',
                },
                dietaryProperties: [
                  { id: 'e095a7b4-8f0b-4b56-8d01-80d39ca0c052', name: 'DAIRY' },
                ],
                name: 'Hello World',
                outOfStock: false,
                restaurantId: 'a352a4a6-541b-45bc-9d08-9f52e921d91b',
                slug: 'Hello World',
                throttleItem: true,
              },
            ],
          },
          {
            id: 'dfbabd38-fdf8-4eb1-9058-7b384c48299b',
            name: 'Hello World',
            isCustom: true,
            products: [
              {
                asset: { url: 'Hello World' },
                calories: -79,
                categoryId: 'Hello World',
                cost: -77,
                description: 'Hello World',
                id: 'f9b1e39b-6d74-4afb-a52f-8a3a6f32f0ed',
                ingredients: [
                  {
                    asset: { url: 'Hello World' },
                    id: 'ef122810-af29-4152-9b27-f2badd9c8f96',
                    name: 'Hello World',
                  },
                  {
                    asset: { url: 'Hello World' },
                    id: 'f010ca15-3964-4297-88b3-94138d500493',
                    name: 'Hello World',
                  },
                  {
                    asset: { url: 'Hello World' },
                    id: '4e080ad7-fd62-4514-9d94-f36b41c23d4c',
                    name: 'Hello World',
                  },
                ],
                isModifiable: false,
                isCustom: true,
                customType: 'BOWL',
                isSalad: true,
                label: {
                  id: '6caa8622-a517-4d3c-bc3f-05167a358d45',
                  name: 'Hello World',
                },
                dietaryProperties: [
                  { id: 'b9313663-db9e-4b2f-917f-534a27f5acfb', name: 'DAIRY' },
                ],
                name: 'Hello World',
                outOfStock: true,
                restaurantId: 'a03bfaf7-e27a-459a-b81e-64855fe3c247',
                slug: 'Hello World',
                throttleItem: false,
              },
              {
                asset: { url: 'Hello World' },
                calories: 74,
                categoryId: 'Hello World',
                cost: -34,
                description: 'Hello World',
                id: 'f38aff27-422c-4629-b316-9f0cff6a9347',
                ingredients: [
                  {
                    asset: { url: 'Hello World' },
                    id: '88d8eee3-0f22-4b94-8d25-3ab94c401307',
                    name: 'Hello World',
                  },
                  {
                    asset: { url: 'Hello World' },
                    id: '664c55f9-f516-4095-a6ed-edc961aaeec3',
                    name: 'Hello World',
                  },
                  {
                    asset: { url: 'Hello World' },
                    id: '6e40545d-8c25-44bf-a759-135291a95511',
                    name: 'Hello World',
                  },
                ],
                isModifiable: true,
                isCustom: true,
                customType: 'BOWL',
                isSalad: true,
                label: {
                  id: 'd1e17121-8cef-44b3-a48f-b0e31ab26ed5',
                  name: 'Hello World',
                },
                dietaryProperties: [
                  { id: 'c4c8c1e2-99d2-4034-8533-85b5d1d6c3a3', name: 'DAIRY' },
                  { id: 'f028c5ae-d636-422b-9666-85446f42ce31', name: 'DAIRY' },
                  { id: '741c5d1b-ce91-4130-9d3f-8c0a7ac54fdb', name: 'DAIRY' },
                ],
                name: 'Hello World',
                outOfStock: true,
                restaurantId: 'cdd3501c-158b-4213-9e52-a78d34f8c519',
                slug: 'Hello World',
                throttleItem: true,
              },
            ],
          },
        ],
      },
    },
  },
};
export const CategoryProductFragmentDoc = gql`
  fragment CategoryProduct on Product {
    asset {
      url
    }
    calories
    categoryId
    cost
    description
    id
    ingredients {
      asset {
        url
      }
      id
      name
    }
    isModifiable
    isCustom
    customType
    isSalad
    label {
      id
      name
    }
    dietaryProperties {
      id
      name
    }
    name
    outOfStock
    restaurantId
    slug
    throttleItem
  }
`;
export const CategoryFragmentDoc = gql`
  fragment Category on MenuCategory {
    id
    name
    isCustom
    products {
      ...CategoryProduct
    }
  }
  ${CategoryProductFragmentDoc}
`;
export const RestaurantMenuFragmentDoc = gql`
  fragment RestaurantMenu on Restaurant {
    id
    slug
    name
    city
    state
    zipCode
    address
    phone
    isOutpost
    hours {
      formatted
    }
    isAcceptingOrders
    notAcceptingOrdersReason
    deliveryFee
    flexMessage
    menu {
      id
      categories {
        ...Category
      }
    }
  }
  ${CategoryFragmentDoc}
`;
export const RestaurantDocument = gql`
  query Restaurant($id: ID!) {
    restaurant(id: $id) {
      ...RestaurantMenu
    }
  }
  ${RestaurantMenuFragmentDoc}
`;

export function useRestaurantQuery(
  options: Omit<Urql.UseQueryArgs<RestaurantQueryVariables>, 'query'>,
) {
  return Urql.useQuery<RestaurantQuery, RestaurantQueryVariables>({
    query: RestaurantDocument,
    ...options,
  });
}
